module.exports = __webpack_public_path__ + "img/allegra_allergy_24_hr_tablets.1fd18b7d.jpg";